// Главные города Казахстана для быстрого доступа
export const MAJOR_CITIES = [
  { name: 'Шымкент', coords: [69.5965, 42.3417], zoom: 11 },
  { name: 'Астана', coords: [71.4704, 51.1694], zoom: 11 },
  { name: 'Алматы', coords: [76.8512, 43.2220], zoom: 11 },
  { name: 'Актобе', coords: [57.2072, 50.2839], zoom: 11 },
  { name: 'Караганда', coords: [73.1088, 49.8047], zoom: 11 },
  { name: 'Тараз', coords: [71.3658, 42.9000], zoom: 11 },
  { name: 'Актау', coords: [51.1481, 43.6508], zoom: 11 },
];

// Полный список городов для поиска
export const ALL_CITIES = [
  ...MAJOR_CITIES,
  { name: 'Павлодар', coords: [77.0000, 52.3000], zoom: 11 },
  { name: 'Семей', coords: [80.2275, 50.4111], zoom: 11 },
  { name: 'Усть-Каменогорск', coords: [82.6286, 49.9481], zoom: 11 },
  { name: 'Костанай', coords: [63.6247, 53.2144], zoom: 11 },
  { name: 'Кызылорда', coords: [65.5089, 44.8528], zoom: 11 },
  { name: 'Атырау', coords: [51.9244, 47.1164], zoom: 11 },
  { name: 'Петропавловск', coords: [69.1456, 54.8667], zoom: 11 },
  { name: 'Туркестан', coords: [68.2517, 43.3000], zoom: 11 },
  { name: 'Кокшетау', coords: [69.3786, 53.2872], zoom: 11 },
  { name: 'Орал', coords: [51.3677, 51.2333], zoom: 11 },
  { name: 'Талдыкорган', coords: [78.3728, 45.0150], zoom: 11 },
];

export const DEFAULT_MAP_LOCATION = {
  center: [69.5965, 42.3417], // Центр Шымкентской области
  zoom: 11, // Уменьшен для показа всей области
};

